import * as t from 'io-ts'

export const UserIO = t.partial({
  username: t.string,
  properties: t.partial({
    username: t.string,
    employee_number: t.string,
    user_id: t.string,
    email: t.string,
    first_name: t.string,
    last_name: t.string,
    is_system: t.boolean,
    phone_number: t.string,
  }),
  admins: t.array(t.unknown),
  od_groups: t.array(t.string),
  tags: t.array(t.unknown),
  status: t.string,
  person_id: t.number,
  ds_status: t.string,
  profile: t.UnknownRecord,
})

export const UserGetResultIO = t.type({
  user: UserIO,
})
export type UserGetResultT = t.TypeOf<typeof UserGetResultIO>
